import RmaPageStore, { IRmaAction, RMA_ACTION_TYPE } from "../../stores/rma-page-store";
import RmaActionApproveModal from "../rma-action-approve-modal/rma-action-approve-modal";
import RmaActionReceiveShipmentModal from "../rma-action-receive-shipment-modal/rma-action-receive-shipment-modal";
import RmaActionReopenModal from "../rma-action-reopen-modal/rma-action-reopen-modal";
import RmaActionCancelModal from "../rma-action-cancel-modal/rma-action-cancel-modal";
import RmaActionRejectModal from "../rma-action-reject-modal/rma-action-reject-modal";
import RmaActionMarkAsDoneModal from "../rma-action-mark-as-done-modal/rma-action-mark-as-done-modal";
import RmaActionRestockModal from "../rma-action-restock-modal/rma-action-restock-modal";
import RefundCalculatorDrawer from "../../components/refund-calculator-drawer/refund-calculator-drawer";
import RmaResolveErrorsModal from "../rma-resolve-errors-modal/rma-resolve-errors-modal";
import RmaActionValidateAllModal from "../rma-action-validate-all-modal/rma-action-validate-all-modal";
import RejectItemPopup from "../rma-reject-items-modal/reject-item-popup";
import ResolveLabelErrorModal from "../resolve-label-error-modal/resolve-label-error-modal";

export interface IRmaToolbarActionModalResolverProps {
    rma: RmaPageStore;
    currentRmaAction: IRmaAction;
    onCloseClick: () => void;
}

const RmaToolbarActionModalResolver: React.FC<IRmaToolbarActionModalResolverProps> = ({
    rma,
    currentRmaAction,
    onCloseClick,
}) => {
    switch (currentRmaAction.type) {
        case RMA_ACTION_TYPE.APPROVE:
            return <RmaActionApproveModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.RECEIVE_SHIPMENT:
            return <RmaActionReceiveShipmentModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.REOPEN:
            return <RmaActionReopenModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.REJECT:
            return <RmaActionRejectModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.CANCEL:
            return <RmaActionCancelModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.MARK_AS_DONE:
            return <RmaActionMarkAsDoneModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.RESTOCK:
            return <RmaActionRestockModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.REFUND:
            if (rma.refundCalculatorStore?.isLoading) {
                return null;
            }
            return <RefundCalculatorDrawer closeAction={onCloseClick} rma={rma} />;
        case RMA_ACTION_TYPE.RESOLVE_ERRORS:
            return <RmaResolveErrorsModal rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.VALIDATE_ALL_ITEMS:
            return <RmaActionValidateAllModal rma={rma} rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.RESOLVE_LABEL_ERROR:
            return <ResolveLabelErrorModal rmaAction={currentRmaAction} onCloseClick={onCloseClick} />;
        case RMA_ACTION_TYPE.REJECT_ITEM:
            return <RejectItemPopup rmaAction={currentRmaAction} onCloseCallback={onCloseClick} rma={rma} />;
        default:
            return null;
    }
};

export default RmaToolbarActionModalResolver;
